import cn from 'classnames'
import Image from 'components/LegacyImage'
import { useGrowthSubcategoriesByIds } from 'libs/client/api/growth'
import { QuizMachineContext } from '../../context'
import { usePersonalizedWayfinding } from './usePersonalizedWayfinding'
import { useQuizLoadingScreenBulletsWayfinding } from './useQuizLoadingScreenBulletsWayfinding'
import appearanceClasses from '../../../common/appearance.module.scss'
import classes from './PersonalizedWayfinding.module.scss'

export const PersonalizedWayfinding = () => {
  const { showLogo, logoAnimationFinished } = usePersonalizedWayfinding()
  const { currentBullets } = useQuizLoadingScreenBulletsWayfinding({
    logoAnimationFinished,
  })

  // Prefetch subcategory data so it's ready when /results loads
  const subcatInterests = QuizMachineContext.useSelector(
    ({ context }) => context.subcatInterests,
  )
  useGrowthSubcategoriesByIds(subcatInterests)

  return (
    <>
      <div
        className={cn('mc-w-100', classes.wayfindingContainer, {
          [appearanceClasses.appearing]: !showLogo,
          [appearanceClasses.appeared]: showLogo && !logoAnimationFinished,
          [appearanceClasses.disappearing]: showLogo && logoAnimationFinished,
        })}
      >
        <div className='d-flex flex-column justify-content-center align-items-center mc-h-100 d-md-none'>
          <Image
            src='https://static.masterclass.com/logo-loading.gif'
            width={170}
            height={170}
          />

          <div className='mc-text-h4 mc-text--5-lines'>
            {currentBullets?.map((bullet) => (
              <p key={bullet} className='mc-mb-4'>
                {bullet}
              </p>
            ))}
          </div>
        </div>

        <div className='flex-column justify-content-center align-items-center mc-h-100 d-none d-md-flex'>
          <Image
            src='https://static.masterclass.com/logo-loading.gif'
            width={242}
            height={242}
          />

          <div className='mc-text-h4 mc-text--5-lines'>
            {currentBullets?.map((bullet) => (
              <p key={bullet} className='mc-mb-4'>
                {bullet}
              </p>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
